// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form[data-v-296328f4] {\n  margin: 20px 0;\n  width: 100%;\n}\n[data-v-296328f4] .inputColor .vxe-cell--label {\n  color: red;\n}\n[data-v-296328f4] .el-textarea__inner {\n  color: red;\n}\n.dialog-footer[data-v-296328f4] {\n  position: absolute;\n  bottom: 0;\n  right: 20px;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  z-index: 99;\n  background-color: white;\n}\n", ""]);
// Exports
module.exports = exports;
